import { Method } from "axios";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
  Select,
  Label,
  Form,
  FormText,
  FormGroup,
} from "design-react-kit";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import useHttp from "../../hooks/useHttp";
import { endpoints } from "../../types/config";
import formReducer, { initialState } from "./CustomFormReducer";
import CodiceFiscale from "codice-fiscale-js";
import CustomModal from "../CustomModal/CustomModal";
import HCaptcha from "@hcaptcha/react-hcaptcha";
interface FormProps { }
type SelectTypePA = "ADMIN" | "IPA";
let isCfInit = true;

const CustomForm: React.FC<FormProps> = () => {
  const [forcePopUp, setForcePopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState("");
  const captchaRef = useRef<HCaptcha>(null);
  const [backendInfo, setBackendInfo] = useState<{
    backOfficeURL: string;
    siteKey: string;
  }>({ backOfficeURL: "", siteKey: "" });
  const navigate = useNavigate();
  const {
    error: fetchAdminError,
    isLoading: isAdminLoading,
    sendRequest: fetchAdministrations,
  } = useHttp();
  const {
    error: registerError,
    isLoading: isRegisterLoading,
    sendRequest: registerUser,
  } = useHttp();

  const {
    error: getBackOfficeURLError,
    isLoading: isGetBackOfficeURLLoading,
    sendRequest: getBackOfficeURL,
  } = useHttp();
  const [formState, dispatchForm] = useReducer(formReducer, initialState);
  const [administrations, setAdministrations] = useState<Administration[]>([]);
  const [captchaToken, setCaptchaToken] = useState<null | string>();
  const [eKey, setEkey] = useState<null | string>();

  const loadAdministrations = async (searchKey: string) => {
    if (searchKey) {
      const response = await fetchAdministrations<
        { success: true; result: Administration[] },
        RequestError
      >(
        {
          baseURL: endpoints.getAdministrations.path,
          params: { search: searchKey },
        },
        (res) => res.success,
        (data) => {
          setAdministrations([...data.result]);
        }
      );
    }
  };
  const loadBackOfficeURL = async () => {
    const response = await getBackOfficeURL<
      { success: true; result: { backOfficeURL: string; siteKey: string } },
      RequestError
    >(
      {
        baseURL: endpoints.gatBackendInfo.path,
      },
      (res) => res.success,
      (data) => {
        setBackendInfo({
          backOfficeURL: data.result.backOfficeURL,
          siteKey: data.result.siteKey,
        });
      }
    );
  };

  const isRegExValid = (regex: RegExp, testString: string): boolean => {
    return regex.test(testString);
  };

  // useEffect(() => {
  //   loadAdministrations("a");
  // }, []);
  const isFormValid = () => {
    //console.log(formState);
    let isValid = true;

    Object.entries(formState).forEach(([key, field]: [string, Field]) => {
      if (key != "phoneNumber") {
        if (field.error || !field.value.length) {
          isValid = false;
          return;
        }
      }
    });

    return isValid;
  };

  const isEmailValid = (email: string) => {
    let domain_list = ['gmail.com', 'yahoo.com', 'yahoo.it', 'virgilio.it', 'outlook.com', 'libero.it', 'email.it', 'mail.com', 'hotmail.it', 'hotmail.com', 'live.it', 'tin.it'];
    let domain = email.substring(email.lastIndexOf("@") + 1);
    if (domain_list.includes(domain))
      return false;
    return true;
  }

  const onLoad = () => {
    // this reaches out to the hCaptcha JS API and runs the
    // execute function on it. you can use other functions as
    // documented here:
    // https://docs.hcaptcha.com/configuration#jsapi

    captchaRef.current?.execute();
  };

  useEffect(() => {
    loadBackOfficeURL();
  }, []);

  useEffect(() => {
    let cf = CodiceFiscale.compute({
      name: formState.name.value,
      surname: formState.surname.value,
      gender: "M",
      day: 24,
      month: 7,
      year: 1957,
      birthplace: "Napoli",
      birthplaceProvincia: "NA", // Optional
    });
    let errorMessage = null;
    if (!isCfInit) {
      if (!formState.fiscalCode.value.length) {
        errorMessage = "Questo campo è obbligatorio";
      } else if (
        formState.fiscalCode.value.length >= 16 &&
        !formState.fiscalCode.value.includes(cf.substring(0, 6))
      ) {
        errorMessage =
          "Nominativo non corrispondente al codice fiscale, si prega di verificare i dati inseriti";
      } else if (!validaCodiceFiscale(formState.fiscalCode.value)) {
        errorMessage = "Codice Fiscale non valido";
      }

      dispatchForm({
        type: "CF",
        payload: {
          ...formState.fiscalCode,
          error: errorMessage,
        },
      });
    }
  }, [
    formState.name.value,
    formState.surname.value,
    formState.fiscalCode.value,
  ]);

  const mapIPA2Admin = (
    option: { value: string; label: string },
    type: SelectTypePA
  ) => {
    if (type == "ADMIN") {
      const entry = administrations.find((admin) => admin._id == option.value);
      if (entry) {
        dispatchForm({
          type: "ADMIN",
          payload: {
            IPA: { value: entry.codice_ipa ?? "", error: null },
            admin: { value: option.label, error: null },
            administrationId: { value: option.value, error: null },
          },
        });
      }
    } else {
      const entry = administrations.find(
        (admin) => admin.codice_ipa == option.value
      );
      if (entry) {
        dispatchForm({
          type: "ADMIN",
          payload: {
            IPA: { value: option.value ?? "", error: null },
            admin: { value: entry.denominazione_ente ?? "", error: null },
            administrationId: { value: entry._id ?? "", error: null },
          },
        });
      }
    }
  };

  return (
    <Container
      style={{
        display: "flex",
        flexWrap: "wrap",

        flexDirection: "column",
      }}>
      <Card spacing className="card-bg card-big border-bottom-card">
        <CardBody>
          <Row>
            <Col>
              <div className="form-row p-2">
                <Input
                  type="text"
                  label="Nome *"
                  invalid={Boolean(formState.name.error)}
                  value={formState.name.value}
                  infoText={formState.name.error ?? ""}
                  maxLength={100}
                  valid={Boolean(
                    formState.name.value.length && !formState.name.error
                  )}
                  onChange={(e) =>
                    dispatchForm({
                      type: "NAME",
                      payload: {
                        value: e.target.value,
                        error: e.target.value.length
                          ? null
                          : "Questo campo è obbligatorio",
                      },
                    })
                  }
                  id="formNome"
                  wrapperClass="col col-md-6"
                />
                <Input
                  type="text"
                  invalid={Boolean(formState.surname.error)}
                  label="Cognome *"
                  value={formState.surname.value}
                  maxLength={100}
                  valid={Boolean(
                    formState.surname.value.length && !formState.surname.error
                  )}
                  infoText={formState.surname.error ?? ""}
                  onChange={(e) =>
                    dispatchForm({
                      type: "SURNAME",
                      payload: {
                        value: e.target.value,
                        error: e.target.value.length
                          ? null
                          : "Questo campo è obbligatorio",
                      },
                    })
                  }
                  id="formCognome"
                  wrapperClass="col col-md-6"
                />
              </div>
              <Input
                type="text"
                label="Email aziendale*"
                id="email"
                value={formState.email.value}
                maxLength={100}
                onChange={(e) => {
                  let errorMessage = null;
                  if (!e.target.value.length) {
                    errorMessage = "Questo campo è obbligatorio";
                  } else if (!isRegExValid(/^\S+@\S+\.\S+$/, e.target.value)) {
                    errorMessage = "E-mail non valida";
                  } else if (!isEmailValid(e.target.value)) {
                    errorMessage = "È necessario indicare un'email aziendale";
                  }
                  dispatchForm({
                    type: "EMAIL",
                    payload: { value: e.target.value, error: errorMessage },
                  });
                }}
                infoText={formState.email.error ?? ""}
                wrapperClass="col"
                valid={Boolean(
                  formState.email.value.length && !formState.email.error
                )}
                invalid={Boolean(formState.email.error)}
              />
            </Col>

          </Row>
          <Row>
            <Col style={{ width: "100%" }}>
              <Input
                type="text"
                label="Telefono ufficio *"
                id="phone"
                minLength={4}
                maxLength={15}
                value={formState.phone.value}
                onChange={(e) => {
                  let errorMessage = null;
                  if (!e.target.value.length) {
                    errorMessage = "Questo campo è obbligatorio";
                  } else if (!isRegExValid(/^[0-9]*$/, e.target.value)) {
                    errorMessage = "Numero di telefono non valido";
                  }
                  if (e.target.value.length < 21) {
                    dispatchForm({
                      type: "PHONE",
                      payload: { value: e.target.value, error: errorMessage },
                    });
                  }
                }}
                infoText={formState.phone.error ?? ""}
                wrapperClass="col"
                valid={Boolean(
                  formState.phone.value.length &&
                  !formState.phone.error
                )}
                invalid={Boolean(formState.phone.error)}
              />

              <Input
                type="text"
                label="Cellulare"
                id="phonenumber"
                minLength={4}
                maxLength={15}
                value={formState.phoneNumber.value}
                onChange={(e) => {
                  let errorMessage = null;
                  if (!isRegExValid(/^[0-9]*$/, e.target.value)) {
                    errorMessage = "Numero di cellulare non valido";
                  }
                  if (e.target.value.length < 21) {
                    dispatchForm({
                      type: "PHONENUMBER",
                      payload: { value: e.target.value, error: errorMessage },
                    });
                  }
                }}
                infoText={formState.phoneNumber.error ?? ""}
                wrapperClass="col"
                valid={Boolean(
                  formState.phoneNumber.value.length &&
                  !formState.phoneNumber.error
                )}
                invalid={Boolean(formState.phoneNumber.error)}
              />
            </Col>

          </Row>
          <Row>
            <Col style={{ width: "100%" }}>
              <Input
                type="text"
                label="Codice fiscale *"
                id="CF"
                value={formState.fiscalCode.value}
                valid={Boolean(
                  formState.fiscalCode.value.length &&
                  !formState.fiscalCode.error
                )}
                onChange={(e) => {
                  isCfInit = false;
                  dispatchForm({
                    type: "CF",
                    payload: {
                      value: e.target.value.toUpperCase(),
                      error: null,
                    },
                  });
                }}
                infoText={formState.fiscalCode.error ?? ""}
                invalid={Boolean(formState.fiscalCode.error)}
                wrapperClass="col"
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ width: "100%" }}>
              <Input
                type="text"
                label="Ruolo ricoperto nell'amministrazione *"
                invalid={Boolean(formState.role.error)}
                value={formState.role.value}
                infoText={formState.role.error ?? ""}
                maxLength={100}
                valid={Boolean(
                  formState.role.value.length && !formState.role.error
                )}
                onChange={(e) =>
                  dispatchForm({
                    type: "ROLE",
                    payload: {
                      value: e.target.value,
                      error: e.target.value.length
                        ? null
                        : "Questo campo è obbligatorio",
                    },
                  })
                }
                id="formRole"
                wrapperClass="col"
              />
            </Col>
          </Row>
          <Col className="mb-4">
            <label htmlFor="admin">
              <strong>Amministrazione *</strong>
            </label>
            <Select
              isClearable={true}
              isLoading={isAdminLoading}
              value={
                formState.admin.value == ""
                  ? null
                  : {
                    label: formState.admin.value,
                    value: formState.admin.value,
                  }
              }
              onInputChange={(srcKey, inputChangeType) => {
                //console.log("Admin src key changed: ", srcKey);
                if (srcKey.length >= 3) {
                  loadAdministrations(srcKey);
                }
              }}
              onChange={(value: { value: string; label: string }) => {
                if (value) {
                  mapIPA2Admin(value, "ADMIN");
                } else {
                  dispatchForm({
                    type: "ADMIN",
                    payload: {
                      IPA: { value: "", error: null },
                      admin: { value: "", error: null },
                      administrationId: { value: "", error: null },
                    },
                  });
                }
              }}
              placeholder="Seleziona una amministrazione"
              options={administrations.map((admin) => ({
                value: admin._id,
                label: admin.denominazione_ente,
              }))}
            />

            {fetchAdminError && (
              <h6 className="text-danger">Errore di connessione.</h6>
            )}
          </Col>
          <Col className="mb-2">
            <label htmlFor="admin">
              <strong>IPA *</strong>
            </label>
            <Select
              isClearable={true}
              isLoading={isAdminLoading}
              value={
                formState.IPA.value == ""
                  ? null
                  : {
                    label: formState.IPA.value,
                    value: formState.IPA.value,
                  }
              }
              onChange={(value: { value: string; label: string }) => {
                if (value) {
                  mapIPA2Admin(value, "IPA");
                } else {
                  dispatchForm({
                    type: "IPA",
                    payload: {
                      IPA: { value: "", error: null },
                      admin: { value: "", error: null },
                      administrationId: { value: "", error: null },
                    },
                  });
                }
              }}
              onInputChange={(srcKey, inputChangeType) => {
                //console.log("IPA src key changed: ", srcKey);
                if (srcKey.length >= 2) {
                  loadAdministrations(srcKey);
                }
              }}
              placeholder="Seleziona un'IPA"
              options={administrations.map((ipa) => ({
                value: ipa.codice_ipa,
                label: ipa.codice_ipa,
              }))}
            />
            {fetchAdminError && (
              <h6 className="text-danger">Errore di connessione.</h6>
            )}
            <div className="mt-5">
              <label htmlFor="admin">
                <strong>Modulo di richiesta registrazione</strong>
              </label>
              <a href="/ModuloDiRichiestaRegistrazione.pdf" target={"_blank"}>
                <p>Clicca qui.</p>
              </a>
              <Input
                id="theFile"
                onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                  let theFile = document.getElementById(
                    "theFile"
                  ) as HTMLInputElement;
                  theFile.value = "";
                  dispatchForm({
                    type: "FILE",
                    payload: {
                      error: null,
                      value: "",
                    },
                  });
                }}
                onChange={(e) => {
                  const file = new FileReader();

                  file.onabort = () => {
                    console.log("abort");
                    dispatchForm({
                      type: "FILE",
                      payload: {
                        error: null,
                        value: "",
                      },
                    });
                  };

                  file.onload = (e) => {
                    if (e.target) {
                      let mimetype = (e.target.result as string).replace("data:", "").split(";")[0],
                        ext = (document.getElementById(
                          "theFile"
                        ) as HTMLInputElement).value.split(".").slice(-1)[0];
                      console.log(ext, mimetype)
                      if (!e.target.result || e.target.result === "") {
                        dispatchForm({
                          type: "FILE",
                          payload: {
                            error: "Inserisci un file valido (.pdf, .p7m)",
                            value: "",
                          },
                        });
                        } else if (!(ext === 'pdf' || ext === 'p7m' )) {
                          console.log(mimetype)
                          dispatchForm({
                            type: "FILE",
                            payload: {
                              error: "Inserisci un file valido (.pdf, .p7m)",
                              value: "",
                            },
                          }); 
                      } else {
                        dispatchForm({
                          type: "FILE",
                          payload: {
                            error: null,
                            value: (e.target.result as string).split(",")[1],
                          },
                        });
                        dispatchForm({
                          type: "FILE_MIMETYPE",
                          payload: {
                            error: null,
                            value: `${ext};${mimetype}`,
                          },
                        });
                      }
                    }
                    file.onloadend = () => {
                      let theFile = document.getElementById(
                        "theFile"
                      ) as HTMLInputElement;
                      //console.log(theFile.value);
                    };
                  };

                  if (e.target && e.target.files && e.target.files[0]) {
                    file.readAsDataURL(e.target.files[0]);
                  }
                }}
                infoText={formState.attachment.error ?? ""}
                invalid={Boolean(formState.attachment.error)}
                className="mt-1"
                type="file"
                accept="application/pdf,application/pkcs7-mime"
              />
              <br />
              <br />
              {backendInfo.siteKey != "" && (
                <HCaptcha
                  sitekey={backendInfo.siteKey}
                  ref={captchaRef}
                  onVerify={(token, ekey) => {
                    setCaptchaToken(token);
                  }}
                />
              )}

              <Form className="mt-4">
                <fieldset>
                  <FormGroup check>
                    <Input
                      id="privacypolicy"
                      type="checkbox"
                      checked={formState.privacyPolicy.value == "true"}
                      onChange={(e) =>
                        dispatchForm({
                          type: "PRIVACYPOLICY",
                          payload: {
                            error: null,
                            value:
                              formState.privacyPolicy.value == "true"
                                ? "false"
                                : "true",
                          },
                        })
                      }
                    />
                    <Label for="privacypolicy" check>
                      Confermo di aver preso visione e di accettare la{" "}
                      <Link target={"_blank"} to="/privacypolicy">
                        privacy policy
                      </Link>{" "}
                      *
                    </Label>
                  </FormGroup>
                </fieldset>
              </Form>
              <br />
              <br />
            </div>
          </Col>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}>
            {isRegisterLoading && (
              <Spinner className="float-right mt-4 mr-4" active="true" />
            )}
            <Button
              className="float-right mt-4"
              size="lg"
              color="primary"
              disabled={
                !isFormValid() ||
                isAdminLoading ||
                formState.privacyPolicy.value != "true" ||
                captchaToken == null ||
                captchaToken === ""
              }
              onClick={async () => {
                const form = new FormData();
                form.append("name", formState.name.value);
                form.append("surname", formState.surname.value);
                form.append("email", formState.email.value);
                form.append("fiscalCode", formState.fiscalCode.value);
                form.append("force", "false");
                form.append("administrationId", formState.administrationId.value);
                form.append("attachment", formState.attachment.value);
                form.append("attachmentMimetype", formState.attachment_mimetype.value);
                form.append("phoneNumber", formState.phoneNumber.value);
                form.append("phone", formState.phone.value);
                form.append("role", formState.role.value);
                form.append("privacyPolicy", formState.privacyPolicy.value);
                form.append("captchaToken", captchaToken ?? "");
                captchaRef.current?.resetCaptcha();
                const response = await registerUser<
                  { success: true; result: boolean },
                  RequestError
                >(
                  {
                    baseURL: endpoints.register.path,
                    method: endpoints.register.method as Method,
                    data: form,
                  },
                  (res) => {
                    if (res.success && typeof res.result == "string") {
                      setPopUpMessage(res.result);
                      setForcePopUp(true);
                      return;
                    }
                    if (!res.success || !res.result) {
                      throw {
                        message: res.message ?? "Registrazione fallita.",
                      };
                    }
                  },
                  (data) => {
                    if (typeof data.result != "string" && data.success) {
                      navigate("/done");
                      setPopUpMessage("");
                    }
                  }
                );
                //console.log("RESPONSE", response);
              }}>
              Registrati
            </Button>
          </div>
          {registerError && (
            <p className="text-danger mt-3">{registerError.message}</p>
          )}
          {backendInfo.backOfficeURL != "" && (
            <label htmlFor="admin">
              <strong>
                Sei già registrato?{" "}
                <a target={"_blank"} href={backendInfo.backOfficeURL}>
                  Clicca qui
                </a>
              </strong>
            </label>
          )}
        </CardBody>
      </Card>
      <CustomModal
        isOpen={forcePopUp}
        isLoading={isRegisterLoading}
        sendButtonColor="primary"
        toggleModal={setForcePopUp}
        closeAction={() => setForcePopUp(false)}
        closeButtonText="Annulla"
        sendButtonText="Continua"
        sendAction={async () => {
          const form = new FormData();
          form.append("name", formState.name.value);
          form.append("surname", formState.surname.value);
          form.append("email", formState.email.value);
          form.append("fiscalCode", formState.fiscalCode.value);
          form.append("force", "true");
          form.append("administrationId", formState.administrationId.value);
          form.append("attachment", formState.attachment.value);
          form.append("attachmentMimetype", formState.attachment_mimetype.value);
          form.append("phoneNumber", formState.phoneNumber.value);
          form.append("phone", formState.phone.value);
          form.append("role", formState.role.value);
          form.append("privacyPolicy", formState.privacyPolicy.value);
          form.append("captchaToken", captchaToken ?? "");

          captchaRef.current?.resetCaptcha();
          //  console.log(formState);
          //captchaRef.current?.resetCaptcha();
          const response = await registerUser<
            { success: true; result: boolean },
            RequestError
          >(
            {
              baseURL: endpoints.register.path,
              method: endpoints.register.method as Method,
              data: form,
            },
            (res) => {
              if (!res.success || !res.result) {
                throw {
                  message: res.message ?? "Registrazione fallita.",
                };
              }
              setForcePopUp(false);
            },
            (data) => {
              if (data.result && data.success) {
                navigate("/done");
              }
            }
          );
          //console.log("RESPONSE", response);
        }}
        titleModal="Sei sicuro di voler continuare?">
        <p>{popUpMessage}</p>
      </CustomModal>
    </Container>
  );
};

export default CustomForm;

function validaCodiceFiscale(cf: string) {
  var validi, i, s, set1, set2, setpari, setdisp;
  if (cf == "") return "";
  cf = cf.toUpperCase();
  if (cf.length != 16) return false;
  validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  for (i = 0; i < 16; i++) {
    if (validi.indexOf(cf.charAt(i)) == -1) return false;
  }
  set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
  setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
  s = 0;
  for (i = 1; i <= 13; i += 2)
    s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  for (i = 0; i <= 14; i += 2)
    s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  if (s % 26 != cf.charCodeAt(15) - "A".charCodeAt(0)) return false;
  return true;
}
